import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { saveLanguage } from "../localization/i18n";

interface LanguageInitializerProps {
  children: React.ReactNode;
}

const LanguageInitializer: React.FC<LanguageInitializerProps> = ({
  children,
}) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // 현재 언어 설정을 로컬 스토리지에 저장 (초기화)
    saveLanguage(i18n.language);
  }, [i18n.language]);

  return <>{children}</>;
};

export default LanguageInitializer;
